<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M11.1 19.2028C11.2 17.5028 12.1 15.8028 13.5 14.8028C13.6 14.7028 13.7 14.7028 13.8 14.6028H8.7C4.9 
    14.6028 2 17.6028 2 21.3028V23.9028C2 24.5028 2.4 24.9028 3 24.9028H13.4C11.8 23.0028 11 21.2028 11.1 19.2028Z"
    fill="#748097"
  />
  <path
    d="M13.0998 12.4029C16.1998 12.4029 18.7998 9.9029 18.7998 6.7029C18.7998 3.6029 16.2998 1.0029 13.0998 
    1.0029C9.8998 0.902898 7.2998 3.4029 7.2998 6.6029C7.2998 9.8029 9.8998 12.4029 13.0998 12.4029Z"
    fill="#748097"
  />
  <path
    d="M12.3002 20.4028H15.9002L18.2002 17.0028L20.5002 20.4028H23.3002L24.9002 22.8028L26.5002 20.4028H30.8002C30.8002 
    20.2028 30.8002 20.0028 30.8002 19.7028C30.8002 18.4028 30.3002 17.1028 29.3002 16.1028C27.3002 14.1028 24.0002 
    14.1028 21.9002 16.1028L21.5002 16.5028L21.1002 16.1028C20.1002 15.1028 18.8002 14.6028 17.4002 14.6028C16.0002 
    14.6028 14.7002 15.1028 13.7002 16.1028C12.7002 17.1028 12.2002 18.4028 12.2002 19.7028C12.2002 20.0028 12.3002 
    20.4028 12.3002 20.4028Z"
    fill="#009DD6"
  />
  <path
    d="M21.6002 31.1029L29.4002 23.3029C29.9002 22.8029 30.3002 22.2029 30.5002 21.6029H27.2002L24.9002 25.0029L22.6002 
    21.6029H19.8002L18.2002 19.2029L16.6002 21.6029H12.7002C13.0002 22.2029 13.3002 22.8029 13.8002 23.3029L21.6002 31.1029Z"
    fill="#009DD6"
  />
</svg>
